<template>
	<div>
		<el-form ref="form" label-position="right" :rules="rules" :model="form" :label-width="formLabelWidth">
			<el-form-item label="机台编号" prop="code">
				<el-input v-model.trim="form.code" autocomplete="off" placeholder="默认显示当前机台编号" maxlength="150" show-word-limit></el-input>
			</el-form-item>
			<el-form-item label="机台名称" prop="name">
				<el-input v-model.trim="form.name" autocomplete="off" placeholder="默认显示当前机台名称" maxlength="150" show-word-limit></el-input>
			</el-form-item>
			<el-form-item label="所在车间">
				<el-select v-model.trim="form.workshop_id" placeholder="车间选择" style="width:150px">
					<el-option v-for="item in workshops" :key="item._id.$oid" :label="item.name" :value="item._id.$oid"> </el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="机台类型" prop="type">
				<el-select v-model.trim="form.type" placeholder="请选择类型">
					<el-option v-for="item in deviceTypeOptions" :label="item.label" :key="item.value" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="机台幅宽" prop="width">
				<el-input v-model.number="form.width" autocomplete="off" placeholder="默认显示当前机台幅宽" style="width:220px">
					<template slot="append">mm</template>
				</el-input>
			</el-form-item>
			<el-form-item label="物料长度" prop="material_len">
				<el-input v-model.number="form.material_len" autocomplete="off" placeholder="物料长度" style="width:220px">
					<template slot="append">mm</template>
				</el-input>
			</el-form-item>
			<el-form-item label="准备时间" prop="pre_time">
				<el-input v-model.number="form.pre_time" autocomplete="off" placeholder="准备时间" style="width:220px">
					<template slot="append">分钟</template>
				</el-input>
			</el-form-item>
			<el-form-item label="良率" prop="yield_rate">
				<el-input v-model.number="form.yield_rate" autocomplete="off" placeholder="良率"></el-input>
			</el-form-item>
			<el-form-item label="白班开始时间">
				<el-time-picker v-model.trim="form.day_time" :picker-options="{ format: 'HH:mm' }" format="HH:mm" value-format="HH:mm" placeholder="默认显示当前白班开始时间"></el-time-picker>
			</el-form-item>
			<el-form-item label="晚班开始时间">
				<el-time-picker v-model.trim="form.night_time" :picker-options="{ format: 'HH:mm' }" format="HH:mm" value-format="HH:mm" placeholder="默认显示当前白班开始时间"></el-time-picker>
			</el-form-item>
			<el-form-item label="相机地址">
				<el-input v-model.trim="form.url" placeholder="相机地址" maxlength="200" ></el-input>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	import deviceType from '@/views/public/DeviceType'
	import { workshopRequest } from '@/network/requests/workshop'
	import { jtInfoRequest } from '@/network/requests/jtInfo'
	export default {
		components: {},
		data() {
			this.formLabelWidth = '120px'

			/**
			 * 设备编号重名检查
			 * @param {*} rule
			 * @param {*} value
			 * @param {*} callback
			 */
			var validateCodeExist = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入设备编号'))
				} else {
					var msg = '设备编号已经存在，请更换编号！'
					//检查名称是否重复。
					jtInfoRequest.queryAll({ code: value }).then(res => {
						if (res.length > 1) {
							callback(new Error(msg))
						} else if (res.length == 1) {
							var data = res[0]

							if (this.form._id) {
								if (data._id.$oid != this.form._id.$oid) {
									callback(new Error(msg))
								} else {
									callback()
								}
							} else {
								callback(new Error(msg))
							}
						} else {
							callback()
						}
					})
				}
			}
				var validateNumber = (rule, value, callback) => {
				 {
					if(value < 0){
						callback(new Error('输入数字必须大于0'))
					}
					callback()
					
				}

			}
			var validateNumberup = (rule, value, callback) => {
				{
					if(value < 0  ||  value >100 ){
						callback(new Error('输入数字范围0~100'))
					}
					callback()
					
				}
			}

			/**
			 * 设备名称重名检查
			 * @param {*} rule
			 * @param {*} value
			 * @param {*} callback
			 */
			var validateNameExist = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入设备名称'))
				} else {
					var msg = '设备名称已存在，请更换名称！'
					//检查名称是否重复。
					jtInfoRequest.queryAll({ name: value }).then(res => {
						if (res.length > 1) {
							callback(new Error(msg))
						} else if (res.length == 1) {
							var data = res[0]

							if (this.form._id) {
								if (data._id.$oid != this.form._id.$oid) {
									callback(new Error(msg))
								} else {
									callback()
								}
							} else {
								callback(new Error(msg))
							}
						} else {
							callback()
						}
					})
				}
			}

			return {
				rules: {
					code: [
						{ required: true, message: '请输入设备编号', trigger: 'blur' },
						{ validator: validateCodeExist, trigger: 'blur' },
					],
					name: [
						{ required: true, message: '请输入设备名称', trigger: 'blur' },
						{ validator: validateNameExist, trigger: 'blur' },
					],
					type: [{ required: true, message: '请选择设备类型', trigger: 'blur' }],
					width: [
						{ required: true, message: '请选择设备类型', trigger: 'blur' },
						{ type: 'number', message: '请输入整数', trigger: 'blur' },
							{ validator: validateNumber, trigger: 'blur' },
					],
					pre_time: [
						{ required: true, message: '请输入准备时间', trigger: 'blur' },
						{ type: 'number', message: '请输入整数', trigger: 'blur' },
						{ validator: validateNumber, trigger: 'blur' },
					],
					material_len: [
						{ required: true, message: '请输入物料长度', trigger: 'blur' },
						{ type: 'number', message: '请输入整数', trigger: 'blur' },
						{ validator: validateNumber, trigger: 'blur' },
					],
					yield_rate: [
						{ required: true, message: '请输入良率', trigger: 'blur' },
						{ type: 'number', message: '请输入整数', trigger: 'blur' },
						{ validator: validateNumberup, trigger: 'blur' },
					],
				},
				workshops: [],
			}
		},
		computed: {
			deviceTypeOptions() {
				return deviceType.options
			},
		},
		props: {
			form: {
				type: Object,
			},
		},
		model: {
			prop: 'form',
			event: 'changeForm',
		},
		methods: {
			changeForm() {
				this.$emit('changeForm', this.form)
			},
			/**
			 *
			 */
			validate(callback) {
				this.$refs.form.validate(valid => {
					callback(valid)
				})
			},
		},
		created() {
			workshopRequest.queryAll().then(res => {
				console.log('获取车间', res)
				this.workshops = res
			})
		},
	}
</script>

<style></style>
